import { KeycloakService } from 'keycloak-angular';
import { environment } from 'src/environments/environment';

export function initializeKeycloak(keycloak: KeycloakService) {
  return async () => {
    try {
      const authenticated = await keycloak.init({
        config: {
          url: environment.baseUrls.keycloak.url,
          realm: environment.baseUrls.keycloak.realm,
          clientId: environment.baseUrls.keycloak.clientId,
        },
        initOptions: {
          checkLoginIframe: false,
          silentCheckSsoRedirectUri:
            window.location.origin + '/assets/silent-check-sso.html',
        },
        enableBearerInterceptor: true,
        bearerExcludedUrls: [],
      });

      return authenticated;
    } catch (error) {
      console.error('Keycloak initialization failed', error);

      /**
       * Decide how the app should behave if auth fails.
       * Options:
       * 1. Allow app to load without auth
       * 2. Redirect to error page
       * 3. Force login
       */

      // Example fallback
      // window.location.href = '/auth-error';

      return false;
    }
  };
}